import { render, staticRenderFns } from "./PolicyCustomizationModal.vue?vue&type=template&id=2c31aa3a&lang=pug&"
import script from "./PolicyCustomizationModal.vue?vue&type=script&lang=js&"
export * from "./PolicyCustomizationModal.vue?vue&type=script&lang=js&"
import style0 from "./PolicyCustomizationModal.vue?vue&type=style&index=0&id=2c31aa3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports